import React from 'react';
import createReactClass from 'create-react-class';
import moment from 'moment';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import SessionStore from 'stores/shared/session';
import _ from 'underscore';
import StoreInterestMixin from 'lib/flux/store/interest_mixin';
import ScreenTransitionable from 'mixins/transitionable';
import AnyguideLogo from 'views/anyguide/layout/logo';
import { loadLocales } from 'services/translation';
import './index.scss';
import { getTranslatedText } from '../helpers';

const ConfirmationMobile = createReactClass({
  displayName: 'ConfirmationMobile-Plugins',
  mixins: [ScreenTransitionable, StoreInterestMixin, PureRenderMixin],

  UNSAFE_componentWillMount() {
    // loadLocales(this.props.tour.i18n_locale);
    const locale = this.props.tour
      ? this.props.tour.i18n_locale
      : this.props.i18n_locale;
    loadLocales(SessionStore.state.get('i18n') || locale); // TODO: replace props.tour.i18n etc with session store throughout front end
  },

  screenTransitionTime: 700,

  getInitialState() {
    return _.extend({}, this.transitionableInitialState());
  },

  getStoreInterests() {
    return _.extend({}, this.transitionableStoreInterests());
  },

  getDefaultProps() {
    return {
      screensStackLast: {
        stackIndex: 0,
      },
      initialScreen: {
        component: 'Views.Plugins.Confirmation.Mobile.Screens.Message',
        props: {},
      },
    };
  },

  getSharedProps() {
    const { tour = {} } = this.props || {};
    const { kiosk_setting = {}, i18n_locale: locale } = tour || {};

    const {
      headline,
      headline_translations: headlineTranslations,
      sub_headline: subHeadline,
      sub_headline_translations: subHeadlineTranslations,
    } = kiosk_setting || {};

    return {
      for_invoice: this.props.for_invoice,
      guest_paid_invoice: this.props.guest_paid_invoice,
      is_live_booking: this.props.is_live_booking,
      guide_full_name: this.props.request.guide_full_name,
      guide_avatar: this.props.request.guide_avatar,
      tour_picture: this.props.request.tour_picture,
      tour_name: this.props.request.tour_name_translation,
      link_color: this.props.request.link_color,
      brand_color: this.props.partner_info.brand_color,
      business_name: this.props.partner_info.business_name,
      custom_title: this.props.tour.translated_confirmation_title_text,
      custom_body: this.props.tour.translated_confirmation_body_text,
      has_resource: this.props.request.has_resource,
      resource_name: this.props.request.resource_name,
      custom_locations_enabled: this.props.tour.custom_locations_enabled,
      location: this.props.location,
      canAdditionalGuestsLink: this.props.can_view_guest_information_page,
      AdditionalGuestsLinkSettings: this.props.additional_guest_settings,
      disable_guest_confirmation_email:
        this.props.disable_guest_confirmation_email,
      numberOfGuests: this.props.request.number_of_guests,
      maxNumberGuests: this.props.request.guest_of_guest_max_guests,
      headline: getTranslatedText(headline, headlineTranslations, locale),
      sub_headline: getTranslatedText(
        subHeadline,
        subHeadlineTranslations,
        locale
      ),
    };
  },

  propsForMessage() {
    return {
      tourist_email: this.props.request.email,
      recipient_id: this.props.request.guide_id_hash,
      sender_id: this.props.request.tourist_id_hash,
      booking_id: this.props.request.booking_id,
      booking_id_hash: this.props.booking_id_hash,
      automatic_booking: this.props.is_auto_booking,
      has_future_availability: this.props.request.has_future_availability,
      guest_reschedulable: this.props.tour.guest_reschedulable,
      link_to_modify: this.props.request.link_to_modify,
      first_name: this.props.request.first_name,
      date: this.props.request.date,
      time: this.props.request.time,
      redirect_url: this.props.request.redirect_url,
      show_details: true,
      paid_in_cash: this.props.request.paid_in_cash,
      has_resource: this.props.request.has_resource,
      resource_name: this.props.request.resource_name,
      online: this.props.tour.online,
      tourTimezone: this.props.tour.tour_timezone,
      experience_link: this.props.request.experience_link,
      live_branding_color: this.props.partner_info.live_branding_color,
      ticketed_event: this.props.request.ticketed_event,
      affiliate_portal_link: this.props.affiliate_portal_link,
      isBookingAffiliate: this.props.is_booking_affiliate,
      isBookingPaid: this.props.is_booking_paid,
      isBookingPending: this.props.is_booking_pending,
      affiliateName: this.props.affiliate_name,
    };
  },

  propsForSummary() {
    return {
      cancellation_policy:
        this.props.request.tour_cancellation_policy_humanized,
      short_cancellation_policy:
        this.props.request.tour_short_cancellation_policy_humanized,
      has_cancellation: this.props.request.has_cancellation,
      duration: this.props.request.duration,
      date: this.props.request.date,
      time: this.props.request.time,
      guests: this.props.request.number_of_guests,
      pricing: this.props.pricing,
      has_resource: this.props.request.has_resource,
      resource_name: this.props.request.resource_name,
    };
  },

  getScreenProps(componentExportName, storeProps) {
    let screenProps = {};
    const component = componentExportName.split('.').pop();
    const screenPropsHandler = `propsFor${component}`;

    if (typeof this[screenPropsHandler] === 'function') {
      screenProps = this[screenPropsHandler]();
    }

    return _.extend({}, this.getSharedProps(), storeProps, screenProps);
  },

  render() {
    const { is_live_booking } = this.props;
    return (
      <div className="ConfirmationMobile-ScreenContainer">
        {this.renderTransitionableScreens()}
        <div className="ConfirmationMobile-LogoContainer">
          {!is_live_booking && <hr className="border" />}
          <a
            aria-label="Anyroad logo a link to the landing page"
            href="http://www.anyroad.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <AnyguideLogo
              type="transparentbg"
              isLiveBooking={is_live_booking}
            />
          </a>
        </div>
      </div>
    );
  },
});

export default ConfirmationMobile;
